/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `CREATED` - Created
 * * `NEW` - New
 * * `WORK_IN_PROGRESS` - Work In Progress
 * * `WAITING_APPROVAL` - Waiting Approval
 * * `COMPLETED` - Completed
 * * `ARCHIVED` - Archived
 * * `REJECTED` - Rejected
 * * `LINKED` - Linked
 * @export
 */
export const MainEventStatusEnum = {
    Created: 'CREATED',
    New: 'NEW',
    WorkInProgress: 'WORK_IN_PROGRESS',
    WaitingApproval: 'WAITING_APPROVAL',
    Completed: 'COMPLETED',
    Archived: 'ARCHIVED',
    Rejected: 'REJECTED',
    Linked: 'LINKED'
} as const;
export type MainEventStatusEnum = typeof MainEventStatusEnum[keyof typeof MainEventStatusEnum];


export function instanceOfMainEventStatusEnum(value: any): boolean {
    for (const key in MainEventStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(MainEventStatusEnum, key)) {
            if (MainEventStatusEnum[key as keyof typeof MainEventStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MainEventStatusEnumFromJSON(json: any): MainEventStatusEnum {
    return MainEventStatusEnumFromJSONTyped(json, false);
}

export function MainEventStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainEventStatusEnum {
    return json as MainEventStatusEnum;
}

export function MainEventStatusEnumToJSON(value?: MainEventStatusEnum | null): any {
    return value as any;
}

export function MainEventStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): MainEventStatusEnum {
    return value as MainEventStatusEnum;
}

